<template>
  <div>
    <input-widget :model="model" :attribute="attribute" type="select2" display-field="${item.name}"
                  :hint="hint" @select2Select="getSelectedBranches()" :items="availableBranches"
                  :rules="rules" :disabled="!availableBranches.length"/>
    <ul v-if="selectedBranches.length > 0" class="list-inline d-inline-block mb-2">
      <li v-for="tag in selectedBranches" :key="tag.uuid" class="list-inline-item">
        <b-form-tag size="lg" @remove="removeTag(tag)" variant="primary">{{ tag.name }}</b-form-tag>
      </li>
    </ul>
  </div>
</template>


<script>
  import InputWidget from "./../components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";
  import _ from "lodash";

  const {mapState: mapStateBranch} = createNamespacedHelpers('setup/branch');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "BranchSelectInputWidget",
    components: {InputWidget},
    data() {
      return {
        selectedBranches: []
      }
    },
    props: {
      model: {
        type: Object,
        required: true
      },
      attribute: {
        type: String,
        required: true
      },
      items: {
        type: Array,
        default: () => []
      },
      hint: {
        type: [Boolean, String],
        default: false
      },
      rules: {
        type: String,
        default: null,
        required: false
      },
    },
    methods: {
      removeTag(tag) {
        this.selectedBranches = _.remove(this.selectedBranches, b => b.uuid !== tag.uuid)
        if (!this.selectedBranches.length) {
          this.model.branch_uuid = '';
        }
        this.model.branch_uuids = this.selectedBranches.map(b => b.uuid);
      },
      getSelectedBranches() {
        this.selectedBranches.push(this.branches.rows.find(b => b.uuid === this.model.branch_uuid))
        this.model.branch_uuids = this.selectedBranches.map(b => b.uuid);
      }
    },
    computed: {
      ...mapStateBranch(['branches']),
      availableBranches() {
        return this.branches.rows.filter(opt => this.selectedBranches.map(b => b.uuid).indexOf(opt.uuid) === -1)
      }
    },
    mounted() {
      this.selectedBranches = this.model.branches || [];
    }
  }
</script>

<style scoped>

</style>
